import React, { useState, useEffect } from "react";
import axios from "axios";
import "./GoldValuationModal.css";

const GoldValuationModal = ({ isOpen, onClose, onUpdate, initialWeights }) => {
  const [goldPrices, setGoldPrices] = useState({});
  const [weights, setWeights] = useState({});
  const [valAdd, setValAdd] = useState("0"); // keep as string, parse once

  const goldTypes = ["999","24K","23K","22K","20K","18K","14K","9K","STONE"];

  // ---- precise decimal helpers ----
  const S10 = 10;      // grams to 1 dp
  const S100 = 100;    // dollars to cents
  const toInt1dp = (v) => Math.round((parseFloat(v) || 0) * S10);
  const toCents  = (v) => Math.round((parseFloat(v) || 0) * S100);

  const fromInt1dp = (n) => n / S10;
  const fromCents  = (n) => n / S100;

  const fmtWeight = (w) => (Number.isFinite(+w) ? (Math.round(w * 10) / 10).toFixed(1) : "0.0");
  const fmtMoney  = (m) => (Number.isFinite(+m) ? (Math.round(m * 100) / 100).toFixed(2) : "0.00");

  useEffect(() => {
    if (!isOpen) return;
    axios.get("https://www.lianfoong.com/api/gold-prices")
      .then(res => { if (res.data?.length) setGoldPrices(res.data[0]); })
      .catch(err => console.error("Error fetching gold prices:", err));
      if (initialWeights && typeof initialWeights === "object") {
     setWeights(initialWeights);
   }
  }, [isOpen]);

  const handleWeightChange = (goldType, value) => {
    // keep what user typed, but parse later; allow "" so the box can clear
    setWeights(prev => ({ ...prev, [goldType]: value }));
  };

  const calculateValuation = () => {
    // sum weights at 1dp precision (grams x10)
    let totalWeightInt = 0;     // integer in tenths of a gram
    let totalValueCent = 0;     // integer in cents

    goldTypes.forEach((t) => {
      const wStr = weights[t] ?? "";
      const wInt = toInt1dp(wStr);                // grams x10 (rounded)
      totalWeightInt += wInt;

      const price = parseFloat(goldPrices[t]) || 0; // per-gram price
      // value = (grams) * (price); compute in cents to avoid float drift
      const valueCent = toCents((wInt / S10) * price);
      totalValueCent += valueCent;
    });

    // add Val Add (in dollars) to cents total
    totalValueCent += toCents(valAdd);

    const totalWeight = fromInt1dp(totalWeightInt);
    const totalValue  = fromCents(totalValueCent);

   const details = {
    weights,        // all entered weights { "999": "1.2", "24K": "0.5", ... }
    prices: goldPrices,
    valAdd,         // additional value entered
    totalWeight,
    totalValue
  };

  onUpdate(fmtWeight(totalWeight), fmtMoney(totalValue), details);
  onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="modal-title">Gold Types</h3>

        <div className="gold-table-container">
          <table className="gold-table">
            <thead>
              <tr>{goldTypes.map((t) => <th key={t}>{t}</th>)}</tr>
            </thead>
            <tbody>
              <tr>
                {goldTypes.map((t) => (
                  <td key={t}>{goldPrices[t] ?? "-"}</td>
                ))}
              </tr>
              <tr>
                {goldTypes.map((t) => (
                  <td key={t}>
                    <input
                      type="number"
                      step="0.1"            // allow 0.1 g steps
                      inputMode="decimal"
                      className="gold-input"
                      value={weights[t] ?? ""}   // keep as string
                      onChange={(e) => handleWeightChange(t, e.target.value)}
                      placeholder="0"
                    />
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        <div className="valuation-section">
          <label>Val Add:</label>
          <input
            type="number"
            step="0.01"
            inputMode="decimal"
            value={valAdd}
            onChange={(e) => setValAdd(e.target.value)}
          />
        </div>

        <div className="modal-buttons">
          <button onClick={calculateValuation}>Update</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default GoldValuationModal;
